export const CUSTOMER_SERVICE_PHONE = "0977558030"
export const EMCE_CUSTOMER_SERVICE_PHONE = "0978467603"
export const FRAUD_CUSTOMER_SERVICE_PHONE = "0974997812"
